var $ = require("jquery");
var MessageCommunicator = require("./MessageCommunicator");
var Strings = require("../resources");
var i18n = require("./Internationalization");
var Constants = require("./Constants");
var Utils = require("./utils");

var CoBrowsingPopup = function(config) {
  this.licenseId = config.licenseId;
  this.$session = $("#co-browsing-session");
  this.$status = $(".status-message");
  this.$statusShort = $(".status-message-short");
  this.$startBtn = $(".action-start");
  this.$stopBtn = $(".action-stop");
  this.$endSessionBtn = $(".action-end");
  this.$syncBtn = $("#sync");
  this.$closeBtn = $(".action-close");
  this.$toggleMinMaxBtn = $(".action-toggle-minimize");
  this.$toggleMaxBtn = $(".js-popup-maximize");
  this.$window = $(".window");
  this.$windowHeaderActions = this.$window.find(".window-header");
  this.$windowActions = this.$window.find(".window-actions");
  this.$body = $("body");
  this.$loadingContainer = $("#loading-container");
  this.document = document;
  this.statusTitle = this.document.querySelector(".js-status-title-minimized");
  var queryString = this.getQueryString();

  this.loadStrings();
  this.addPopupResizeListener();
  this.messageCommunicator = new MessageCommunicator()
    .setReceiver(window.parent)
    .setReceiverDomain(queryString.receiverDomain);
};

CoBrowsingPopup.DEFAULT_CLASS_NAME = "status-default";
CoBrowsingPopup.SYNC_CLASS_NAME = "status-sync";
CoBrowsingPopup.CONNECTED_CLASS_NAME = "status-connected";
CoBrowsingPopup.CONNECTING_CLASS_NAME = "status-connecting";
CoBrowsingPopup.READY_CLASS_NAME = "status-ready";
CoBrowsingPopup.REPLICA_DISCONNECTED_CLASS_NAME = "status-replica-disconnected";
CoBrowsingPopup.DISCONNECTED_CLASS_NAME = "status-disconnected";
CoBrowsingPopup.ENDED_CLASS_NAME = "status-ended";
CoBrowsingPopup.CONNECTION_ERROR_CLASS_NAME = "status-connection-error";
CoBrowsingPopup.MINIMIZED_CLASS_NAME = "minimized";
CoBrowsingPopup.MINIMIZED_BODY_CLASS_NAME = "minimized-body";
CoBrowsingPopup.AUTO_MINIMIZE_TIME = 3000;

CoBrowsingPopup.CLASS_NAME_LIST = [
  CoBrowsingPopup.DEFAULT_CLASS_NAME,
  CoBrowsingPopup.SYNC_CLASS_NAME,
  CoBrowsingPopup.CONNECTED_CLASS_NAME,
  CoBrowsingPopup.CONNECTING_CLASS_NAME,
  CoBrowsingPopup.READY_CLASS_NAME,
  CoBrowsingPopup.REPLICA_DISCONNECTED_CLASS_NAME,
  CoBrowsingPopup.DISCONNECTED_CLASS_NAME,
  CoBrowsingPopup.ENDED_CLASS_NAME,
  CoBrowsingPopup.CONNECTION_ERROR_CLASS_NAME
];

CoBrowsingPopup.prototype.addPopupResizeListener = function() {
  const element = this.document.querySelector(".window");

  Utils.addResizeListener(element, (props) => {
    this.messageCommunicator.send("co-browsing:popup-resize", props);
  });
};

CoBrowsingPopup.prototype.setStatusTitleFocusable = function() {
  const isScrollVisible = Utils.isScrollVisible(this.statusTitle);

  if (isScrollVisible) {
    this.statusTitle.setAttribute("tabindex", "0");
  } else {
    this.statusTitle.setAttribute("tabindex", "-1");
  }
};

CoBrowsingPopup.prototype.setStatusTitleFocusableRetry = function(num) {
  let elementIsVisible = Utils.isElementVisible(this.statusTitle);
  let statusTimer;
  let increment = 0;
  let retries = num || 5;
  if ((increment < retries) && elementIsVisible) {
    statusTimer = setInterval(() => {
      this.setStatusTitleFocusable();
      increment += 1;
    }, 500);
  } else {
    clearInterval(statusTimer);
  }
};

CoBrowsingPopup.prototype.loadStrings = function() {
  // Load the default strings
  const currentDocument = this.document;
  const currentLang = i18n.getCurrentLanguageFromSearch(currentDocument) || i18n.getCurrentLanguageAttribute(currentDocument);

  i18n.setDocumentElementLang(currentLang, currentDocument);
  i18n.load(Strings[currentLang], currentLang);
  i18n.setCustomerLanguage(currentLang);
};

CoBrowsingPopup.prototype.loadCustomStrings = function(strings) {
  // Load the custom strings
  if (strings) {
    i18n.load(strings, "custom");
    this.applyStrings();
  }
};

CoBrowsingPopup.prototype.applyStrings = function() {
  i18n.translateFragment($(document.head));
  i18n.translateFragment($(document.body));
  this.setStatus();
  this.hideLoading();
};

CoBrowsingPopup.prototype.init = function() {
  var self = this;
  var messageHandler = this.messageHandler.bind(this);
  this.messageCommunicator.onMessage(messageHandler);

  this.$startBtn.click(function(e) {
    e.preventDefault();
    this.startCoBrowsing();

    setTimeout(function() {
      self.$stopBtn.focus();
    }, Constants.POPUP_SET_TIMEOUT);
  }.bind(this));

  this.$endSessionBtn.click(function(e) {
    e.preventDefault();
    this.restoreFocusToTriggerElement();
    this.stopCoBrowsing();
    this.closeCoBrowsingPopup();
  }.bind(this));

  this.$stopBtn.click(function(e) {
    e.preventDefault();
    this.stopCoBrowsing();

    setTimeout(function() {
      self.$startBtn.focus();
    }, Constants.POPUP_SET_TIMEOUT);
  }.bind(this));

  this.$closeBtn.click(function(e) {
    e.preventDefault();
    this.restoreFocusToTriggerElement();
    this.closeCoBrowsingPopup();
  }.bind(this));

  this.$toggleMinMaxBtn.click(function(e) {
    e.preventDefault();
    this.toggleCoBrowsingPopup();
    this.setStatusTitleFocusableRetry();
  }.bind(this));

  this.$syncBtn.click(function(e) {
    e.preventDefault();
    this.syncCoBrowsing();
  }.bind(this));

  /**
   * Session ID is an element with contenteditable attribute to provide tab selection,
   * It is necessary to block editing the session value but in the same time allows
   * user to select text and copy
   */
  this.$session.keydown(function(e) {
    const allowedKey = [
      "Tab",
      "ShiftLeft",
      "ShiftRight",
      "MetaLeft",
      "MetaRight",
      "ArrowUp",
      "ArrowRight",
      "ArrowDown",
      "ArrowLeft",
      "c"
    ];
    if (!e.metaKey && !allowedKey.includes(e.code)) {
      e.preventDefault();
    }
  });

  this.getCoBrowsingStatus();
  this.requireStrings();
  this.toggleButtonEnabled(true);
  this.setStatusTitleFocusableRetry();
};

CoBrowsingPopup.prototype.getLicenseId = function() {
  return this.licenseId;
};

CoBrowsingPopup.prototype.setCoBrowsingPopupDimensions = function(dimensions) {
  this.messageCommunicator.send("co-browsing:set-popup-dimensions", dimensions);
};

CoBrowsingPopup.prototype.getQueryString = function() {
  var a = window.location.search.substr(1).split("&");

  if (a === "") {
    return {};
  }

  var b = {};
  for (var i = 0; i < a.length; ++i) {
    var p = a[i].split("=");
    if (p.length !== 2) continue;
    b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
  }

  return b;
};

CoBrowsingPopup.prototype.startCoBrowsing = function() {
  this.messageCommunicator.send("co-browsing:start");
};

CoBrowsingPopup.prototype.stopCoBrowsing = function() {
  this.messageCommunicator.send("co-browsing:stop");
};

CoBrowsingPopup.prototype.syncCoBrowsing = function() {
  this.messageCommunicator.send("co-browsing:sync");
};

CoBrowsingPopup.prototype.getCoBrowsingStatus = function() {
  this.messageCommunicator.send("co-browsing:status");
};

CoBrowsingPopup.prototype.closeCoBrowsingPopup = function() {
  this.messageCommunicator.send("co-browsing:close");
};

/**
 * Requests the parent frame to restore focus to the element that originally
 * triggered the popup. The parent resolves the stored CSS selector using the
 * localStorage → cookie → in-memory fallback chain.
 *
 * This method sends a `"co-browsing:restore-focus"` message via the
 * MessageCommunicator so that Primary.js can perform the focus restoration
 * within the correct browsing context.
 */
CoBrowsingPopup.prototype.restoreFocusToTriggerElement = function() {
  this.messageCommunicator.send("co-browsing:restore-focus");
};

CoBrowsingPopup.prototype.toggleCoBrowsingPopup = function() {
  this.messageCommunicator.send("co-browsing:toggle-popup");
};

CoBrowsingPopup.prototype.setCoBrowsingPopup = function(popupState) {
  this.messageCommunicator.send("co-browsing:set-popup", popupState);
};

CoBrowsingPopup.prototype.requireStrings = function() {
  this.messageCommunicator.send("co-browsing:strings");
};

CoBrowsingPopup.prototype.setPopupView = function(className) {
  CoBrowsingPopup.CLASS_NAME_LIST.forEach(function(entry, list) {
    this.$window.removeClass(entry);
  }.bind(this));

  this.$window.addClass(className);
};

CoBrowsingPopup.prototype.messageHandler = function(type, data) {
  switch (type) {
    case Constants.STATUS_CONNECTING:
      this._handleConnecting(data);
      break;

    case Constants.STATUS_READY:
      this._handleReady(data);
      break;

    case Constants.STATUS_CONNECTED:
      this._handleConnected(data);
      break;

    case Constants.STATUS_REPLICA_DISCONNECTED:
      this._handleReplicaDisconnected(data);
      break;
    case Constants.STATUS_CONNECTION_ERROR:
      this._handleConnectionError(data);
      break;
    case Constants.STATUS_SYNC_REQUIRED:
      this._handleSyncRequired(data);
      break;

    case Constants.STATUS_INVALID_LICENSE:
    case Constants.STATUS_DISABLED_LICENSE:
    case Constants.STATUS_LIMITED_LICENSE:
    case Constants.STATUS_INVALID_DOMAIN_FOR_LICENSE:
      this._handleInvalidLicense(data);
      break;

    case Constants.STATUS_DISCONNECTED:
      this._handleDisconnected(data);
      break;

    case Constants.STATUS_ENDED:
      this._handleEnded(data);
      break;

    case Constants.STATUS_CUSTOM_STRINGS:
      this._handleCustomStrings(data);
      break;

    case Constants.POPUP_STATE:
      this._handlePopupState(data);
      break;

    case Constants.POPUP_DRAG_STARTED:
      this._handleDragStart();
      break;
  }

  // NOTE: if popup opened
  // set popup dimensions on parent popupContainer
  if (data === Constants.POPUP_STATE_MAXIMIZED) {
    this._handlePopupDimensions();
  }

  // NOTE: if popup opened
  // set focus on first focusable element
  if (
    type === Constants.POPUP_STATE &&
    data === Constants.POPUP_STATE_MAXIMIZED
  ) {
    this.setFirstFocusableElement();
  }

  // NOTE: if popup minimized
  // set focus on max btn
  if (
    type === Constants.POPUP_STATE &&
    data === Constants.POPUP_STATE_MINIMIZED
  ) {
    this.$toggleMaxBtn.focus();
  }
};

CoBrowsingPopup.prototype.setFirstFocusableElement = function() {
  var setFocus = true;
  var focusableElements =
    "button:not([aria-disabled='true'])," +
    "[href]," +
    "input," +
    "select," +
    "textarea," +
    "[tabindex]:not([tabindex='-1'])"
  ;
  var modal = this.document.querySelector(".window");

  if (modal) {
    var modalHeader = modal.querySelector(".window-header");
    var modalActions = modal.querySelector(".window-actions");
    var focusableHeader = modalHeader && modalHeader.querySelectorAll(focusableElements);
    var focusableActions = modalActions && modalActions.querySelectorAll(focusableElements);
    var firstFocusableElement = focusableHeader[0];

    focusableActions.forEach(function(element) {
      if (element === document.activeElement) {
        setFocus = false;
      }
    });

    if (setFocus && firstFocusableElement) {
      this.document.body.focus();
      firstFocusableElement.focus();
    }
  }
};

CoBrowsingPopup.prototype._handlePopupDimensions = function() {
  var popupDimensions = this.getPopupDimensions();
  this.setCoBrowsingPopupDimensions(popupDimensions);
};

CoBrowsingPopup.prototype.getPopupDimensions = function() {
  this.modal = this.document.querySelector(".window") || null;

  if (!this.modal) {
    return;
  }

  return {
    width: this.modal.offsetWidth,
    height: this.modal.offsetHeight
  };
};

CoBrowsingPopup.prototype.toggleButtonEnabled = function(enabled = true) {
  const ariaDisabled = enabled ? "false" : "true";
  this.$windowHeaderActions.find("button").attr("aria-disabled", ariaDisabled);
  this.$windowHeaderActions.find(`button.${this.currentStatus}`).removeAttr("aria-disabled");
  this.$windowActions.find(".btn-group-inline").find("button").attr("aria-disabled", ariaDisabled);
  this.$windowActions.find(`.${this.currentStatus}`).find("button").removeAttr("aria-disabled");
};

CoBrowsingPopup.prototype._handlePopupState = function(popupState) {
  if (popupState === Constants.POPUP_STATE_MINIMIZED) {
    this.$window.addClass(CoBrowsingPopup.MINIMIZED_CLASS_NAME);
    this.$body.addClass(CoBrowsingPopup.MINIMIZED_BODY_CLASS_NAME);
    this.toggleButtonEnabled(false);
  } else {
    this.$window.removeClass(CoBrowsingPopup.MINIMIZED_CLASS_NAME);
    this.$body.removeClass(CoBrowsingPopup.MINIMIZED_BODY_CLASS_NAME);
    this.toggleButtonEnabled(true);
  }
};

CoBrowsingPopup.prototype._handleConnecting = function(data) {
  if (data && data.sessionId) {
    this.setSession(data.sessionId);
  }
  this.setPopupView(CoBrowsingPopup.CONNECTING_CLASS_NAME);
  this.setStatus(Constants.STATUS_CONNECTING);
};

CoBrowsingPopup.prototype._handleReady = function(data) {
  if (data && data.sessionId) {
    this.setSession(data.sessionId);
  }
  this.setPopupView(CoBrowsingPopup.READY_CLASS_NAME);
  this.setStatus(Constants.STATUS_READY);

  this.setAutoMinimizeTimeout();
};

CoBrowsingPopup.prototype.clearAutoMinimizeTimeout = function() {
  clearTimeout(this.autoMinimizeTimeout);
  this.autoMinimizeTimeout = null;
};

CoBrowsingPopup.prototype.setAutoMinimizeTimeout = function() {
  this.clearAutoMinimizeTimeout();
  this.autoMinimizeTimeout = setTimeout(() => this.handleAutoMinimize(), CoBrowsingPopup.AUTO_MINIMIZE_TIME);
};

CoBrowsingPopup.prototype.handleAutoMinimize = function() {
  if (this.isConnected()) {
    this.setCoBrowsingPopup(Constants.POPUP_STATE_MINIMIZED);
  }
};

CoBrowsingPopup.prototype._handleConnected = function(data) {
  if (data && data.sessionId) {
    this.setSession(data.sessionId);
  }
  this.setPopupView(CoBrowsingPopup.CONNECTED_CLASS_NAME);
  this.setStatus(Constants.STATUS_CONNECTED);
};

CoBrowsingPopup.prototype._handleReplicaDisconnected = function(data) {
  let popupView;
  let status;

  if (this.isConnected()) {
    popupView = CoBrowsingPopup.REPLICA_DISCONNECTED_CLASS_NAME;
    status = Constants.STATUS_REPLICA_DISCONNECTED;

  } else {
    popupView = CoBrowsingPopup.CONNECTION_ERROR_CLASS_NAME;
    status = Constants.STATUS_CONNECTION_ERROR;
  }

  if (data && data.sessionId) {
    this.setSession(data.sessionId);
  }

  this.setPopupView(popupView);
  this.setStatus(status);
};

CoBrowsingPopup.prototype._handleConnectionError = function(data) {
  if (data && data.sessionId) {
    this.setSession(data.sessionId);
  }
  this.setPopupView(CoBrowsingPopup.CONNECTION_ERROR_CLASS_NAME);
  this.setStatus(Constants.STATUS_CONNECTION_ERROR);
};

CoBrowsingPopup.prototype._handleSyncRequired = function(data) {
  if (data && data.sessionId) {
    this.setSession(data.sessionId);
  }
  this.setPopupView(CoBrowsingPopup.SYNC_CLASS_NAME);
  this.setStatus(Constants.STATUS_SYNC_REQUIRED);
};

CoBrowsingPopup.prototype._handleInvalidLicense = function() {
  this.setSession("");
};

CoBrowsingPopup.prototype._handleDisconnected = function() {
  var isEndedByAgent = this.isAlreadyEnded();
  var popupView = CoBrowsingPopup.DEFAULT_CLASS_NAME;
  var status = Constants.STATUS_NOT_STARTED;

  if (!isEndedByAgent && this.currentStatus) {
    popupView = CoBrowsingPopup.DISCONNECTED_CLASS_NAME;
  }

  if (isEndedByAgent) {
    status = Constants.STATUS_ENDED;
    this.restorePopup();
  }

  this.setSession("");
  this.setPopupView(popupView);
  this.setStatus(status);
};

CoBrowsingPopup.prototype._handleEnded = function(data) {
  if (data && data.sessionId) {
    this.setSession(data.sessionId);
  }
  this.setPopupView(CoBrowsingPopup.ENDED_CLASS_NAME);
  this.setStatus(Constants.STATUS_ENDED);
};

CoBrowsingPopup.prototype._handleCustomStrings = function(data) {
  this.loadCustomStrings(data);
};

CoBrowsingPopup.prototype._handleDragStart = function() {
  this.clearAutoMinimizeTimeout();
};

CoBrowsingPopup.prototype.isConnected = function() {
  return this.currentStatus === Constants.STATUS_CONNECTED || this.currentStatus === Constants.STATUS_READY;
};

CoBrowsingPopup.prototype.isAlreadyEnded = function() {
  return this.currentStatus === Constants.STATUS_ENDED;
};

CoBrowsingPopup.prototype.setStatus = function(status) {
  this.currentStatus = status || this.currentStatus;
  const i18nStatus = i18n.t("status-" + this.currentStatus);
  const i18nStatusShort = i18n.t("status-" + this.currentStatus + "-short");

  this.$status.text(i18nStatus);
  this.$statusShort.text(i18nStatus || i18nStatusShort);
};

CoBrowsingPopup.prototype.setSession = function(session) {
  if (session) {
    this.$session.text(session);

  } else {
    this.$session.html("&nbsp;");
  }
};

CoBrowsingPopup.prototype.hideLoading = function() {
  this.$loadingContainer.hide();
};

CoBrowsingPopup.prototype.restorePopup = function() {
  if (this.$window.hasClass(CoBrowsingPopup.MINIMIZED_CLASS_NAME)) {
    this.toggleCoBrowsingPopup();
  }
};

module.exports = CoBrowsingPopup;
